import {initialState} from "./reducer";
import {createSelector} from "reselect";

const getRedirectUrl = state => state.get('redirect', initialState);

const makeRedirectUrl = () => createSelector(getRedirectUrl, redirectUrlState => redirectUrlState.get('redirectState'));

export {getRedirectUrl, makeRedirectUrl}


// WEBPACK FOOTER //
// ./src/redux/global/redirect/selector.js